import { TReduxActions } from '../../types/redux';
import { EPaymentStateActions } from '../../constants/actionTypes/paymentStatusActions';
import { IPaymentState } from '../../types/redux/states';

export const initialState: IPaymentState = {};

export const paymentReducer = (state = initialState, action: TReduxActions): IPaymentState => {
  switch (action.type) {
    case EPaymentStateActions.SET_STATUS:
      return {
        ...state,
        paymentStatus: action.payload,
      };
    case EPaymentStateActions.SET_ID:
      return {
        ...state,
        paymentId: action.payload,
      };
    case EPaymentStateActions.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};
